import { render, staticRenderFns } from "./preguntasFrecuentes.vue?vue&type=template&id=7d24e3cd&"
import script from "./preguntasFrecuentes.vue?vue&type=script&lang=js&"
export * from "./preguntasFrecuentes.vue?vue&type=script&lang=js&"
import style0 from "./preguntasFrecuentes.scss?vue&type=style&index=0&prod&lang=scss&"
import style1 from "../iniciarSesion/iniciarSesion.scss?vue&type=style&index=1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports